import script from "./CTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTable.vue?vue&type=script&setup=true&lang=ts"

import "./CTable.vue?vue&type=style&index=0&id=f834fe94&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f834fe94"]])

export default __exports__